import React, { useEffect, useRef, useState } from "react";
import { Button, Container, Modal, Spinner, Table } from "react-bootstrap";
import {
  Autocomplete,
  TextField,
  Typography,
  createFilterOptions,
} from "@mui/material";
import TableContent from "../../table/table";
import NEMPsearch from "../../popups/empsearch/empsearch";
import { useDispatch, useSelector } from "react-redux";
import { GetAllEmployeeAction } from "../../../../redux/actions/employeeActions";
import notify from "../../../Notifcation";
import {
  CreateHolidayAction,
  DeleteHolidayAction,
  GetAllHolidayAction,
  UpdateHolidayAction,
} from "../../../../redux/actions/HolidayActions";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../Utility/Pagination/Pagination";
import { useTableExcelExport } from "../../../Utility/useTableExcelExport";
import { useReactToPrint } from "react-to-print";
import FormPrintView from "../../../Utility/FormPrintView/FormPrintView";
import { formatPrintValue, filterByEmployeeName } from "../../../Utility/FormPrintView/formPrintHelpers";
const filter = createFilterOptions();
const Enter = ({ userData }) => {
  const [EmployeesId, setEmployeesId] = useState(null);
  const [annualVacation, setannualVacation] = useState(0);
  const [VacationId, setVacationId] = useState(0);
  const [regularVacation, setregularVacation] = useState(0);
  const [casualVacation, setcasualVacation] = useState(0);
  const [sickVacation, setsickVacation] = useState(0);
  const [Search, setSearch] = useState("");
  const myDivRefWorkcom = useRef();
  const { tableRef, onDownload } = useTableExcelExport(
    "بيانات الإجازات",
    "بيانات الإجازات",
  );
  const AllEmplyee = useSelector((state) => state.EmployeeR.GetEmployee);
  const All = useSelector((state) => state.HolidayR.GetHoliday);

  const PageSize = 7;
  const dispatch = useDispatch();
  const [showManage, setshowManage] = useState(false);
  const [Eye, setEye] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const buildSearchQuery = (page = 1) => {
    const query = { pageNumber: page, pageSize: PageSize };
    if (Search.trim()) query.searchTerm = Search.trim();
    return query;
  };

  const filteredHolidays = filterByEmployeeName(All?.data, Search);

  useEffect(() => {
    dispatch(GetAllEmployeeAction());
    dispatch(GetAllHolidayAction(buildSearchQuery()));
  }, []);

  const handleSearch = async () => {
    await dispatch(GetAllHolidayAction(buildSearchQuery()));
  };

  const [showDelete, setshowDelete] = useState(false);
  const onPress = async (page) => {
    await dispatch(GetAllHolidayAction(buildSearchQuery(page)));
  };
  const current = All?.currentPage;

  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setVacationId(itemid);
  };

  const handleCloseManage = () => {
    dispatch(GetAllEmployeeAction());

    setshowManage(false);
  };
  const handleShowManage = () => setshowManage(true);

  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteHolidayAction(VacationId));
    setLoading(false);
    setVacationId(null);
    setshowDelete(false);
    setIsPress(false);
  };
  const handlePrint = useReactToPrint({
    contentRef: myDivRefWorkcom,
    documentTitle: "بيانات الإجازات",
  });

  const handlesubmit = async (e) => {
    e.preventDefault();
    if (
      annualVacation === "" ||
      EmployeesId === null ||
      regularVacation === "" ||
      casualVacation === "" ||
      sickVacation === ""
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }

    if (userData.subscriptionType === "Ended-Subscription") {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.subscriptionType === "User-not-subscriped" &&
      All.data &&
      All.data.length > 4
    ) {
      notify("غير مسموح بأضافة اكثر من 5 من الاجازات إشترك للتفعيل ", "error");
      return;
    }
    if (
      userData.subscriptionType === "User-not-subscriped" &&
      current > 1 &&
      All.data.length > 4
    ) {
      notify("غير مسموح بأضافة اكثر من 5 من الاجازات إشترك للتفعيل ", "error");
      return;
    }

    setIsPress(true);
    setLoading(true);

    const Data = {
      employeeId: EmployeesId.id,
      annualVacation: annualVacation,
      regularVacation: regularVacation,
      casualVacation: casualVacation,
      sickVacation: sickVacation,
    };

    await dispatch(CreateHolidayAction(Data));
    setEmployeesId("");
    setannualVacation(0);
    setregularVacation(0);
    setcasualVacation(0);
    setsickVacation(0);
    setIsPress(false);
    setLoading(false);
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (
      annualVacation === "" ||
      EmployeesId === null ||
      regularVacation === "" ||
      casualVacation === "" ||
      sickVacation === ""
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }

    if (userData.subscriptionType === "Ended-Subscription") {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsPaid-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.isActive === false &&
      userData.subscriptionType === "IsFree-Subscription"
    ) {
      notify("تم انتهاء اشتراكك برجاء التجديد", "error");
      return;
    }
    if (
      userData.subscriptionType === "User-not-subscriped" &&
      All.data &&
      All.data.length > 4
    ) {
      notify("غير مسموح بأضافة اكثر من 5 من الاجازات إشترك للتفعيل ", "error");
      return;
    }
    if (
      userData.subscriptionType === "User-not-subscriped" &&
      current > 1 &&
      All.data.length > 4
    ) {
      notify("غير مسموح بأضافة اكثر من 5 من الاجازات إشترك للتفعيل ", "error");
      return;
    }

    setIsPress(true);
    setLoading(true);

    const Data = {
      id: VacationId,
      applicationUserId: EmployeesId.id,
      annualVacation: annualVacation,
      regularVacation: regularVacation,
      casualVacation: casualVacation,
      sickVacation: sickVacation,
    };
    await dispatch(UpdateHolidayAction(Data));
    setEmployeesId("");
    setannualVacation(0);
    setregularVacation(0);
    setcasualVacation(0);
    setVacationId("");
    setIsPress(false);
    setIsEdit(false);
    setLoading(false);
  };

  const Update = (item) => {
    setEmployeesId({
      name: item.employeeName,
      id: item.employeeId,
    });
    setannualVacation(item.annualVacation);
    setregularVacation(item.regularVacation);
    setcasualVacation(item.casualVacation);
    setsickVacation(item.sickVacation);
    setVacationId(item.id);
    setIsEdit(true);
    setEye(false);
  };
  const Showw = (item) => {
    setEmployeesId({
      name: item.employeeName,
      id: item.employeeId,
    });
    setannualVacation(item.annualVacation);
    setregularVacation(item.regularVacation);
    setcasualVacation(item.casualVacation);
    setsickVacation(item.sickVacation);

    setIsEdit(false);
    setEye(true);
  };

  const res = useSelector((state) => state.HolidayR.AddHoliday);
  const UP = useSelector((state) => state.HolidayR.UpdateHoliday);
  const DEL = useSelector((state) => state.HolidayR.DeleteHoliday);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (
            res.data &&
            res.data.responseMessage === "Great, holiday added successfully"
          ) {
            dispatch(GetAllHolidayAction(buildSearchQuery()));
            notify("تم اضافة البيانات بنجاح", "success");
          }
          if (
            res.data &&
            res.data.responseMessage ===
              "Sorry, this user already have existing holiday record"
          ) {
            dispatch(GetAllHolidayAction(buildSearchQuery()));
            notify("هذا الموظف بالفعل لدية اجازات", "warn");
          }
        } else if (res.status !== 200 || res.status !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (UP) {
        if (UP.status === 200 || UP.status === 201) {
          if (
            UP.data &&
            UP.data.responseMessage === "Great, holiday updated Successfully"
          ) {
            dispatch(GetAllHolidayAction(buildSearchQuery()));
            notify("تم تحديث البيانات بنجاح", "success");
          }
        } else if (UP.status !== 200 || UP.status !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (DEL) {
        if (DEL.statusCode === 200 || DEL.statusCode === 201) {
          if (
            DEL &&
            DEL.responseMessage === "Great, holiday deleted successfully"
          ) {
            dispatch(GetAllHolidayAction(buildSearchQuery()));
            notify("تم حذف البيانات بنجاح", "success");
          }
        } else if (DEL.statusCode !== 200 || DEL.statusCode !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);

  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container">
              <Autocomplete
                value={EmployeesId}
                onChange={(event, newValue) => {
                  if (typeof newValue === "string") {
                    setEmployeesId({
                      name: newValue,
                    });
                  } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setEmployeesId({
                      name: newValue.inputValue,
                    });
                  } else {
                    setEmployeesId(newValue);
                  }
                }}
                filterOptions={(options, params) => {
                  const filtered = filter(options, params);

                  const { inputValue } = params;
                  // Suggest the creation of a new value
                  const isExisting = options.some(
                    (option) => inputValue === option.name,
                  );
                  if (inputValue !== "" && !isExisting) {
                    filtered.push({
                      inputValue,
                      // title: `لا توجد حسابات بهذا الاسم"${inputValue}"`,
                    });
                  }

                  return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={
                  Array.isArray(AllEmplyee && AllEmplyee.data)
                    ? AllEmplyee.data.filter((e) => e.isAccountActive === true)
                    : []
                }
                getOptionLabel={(option) => {
                  // Value selected with enter, right from the input
                  if (typeof option === "string") {
                    return option;
                  }
                  // Add "xxx" option created dynamically
                  if (option.inputValue) {
                    return option.inputValue;
                  }
                  // Regular option
                  return option.name;
                }}
                renderOption={(props, option) => (
                  <li {...props}>{option.name}</li>
                )}
                sx={{ width: 300 }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        اسم الموظف
                        <span style={{ color: "red", fontSize: "21px" }}>
                          *
                        </span>
                      </Typography>
                    }
                  />
                )}
              />
              {/* <i
                className="ty fa-solid fa-magnifying-glass"
                onClick={handleShowManage}
                style={{ color: "#1866ec" }}></i> */}
            </div>
            <div className="inp-container">
              <TextField
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    اجازة سنوية (بالايام)
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                value={annualVacation}
                onChange={(e) => setannualVacation(e.target.value)}
                focused
                type="number"
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    اجازة اعتيادية (بالايام)
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                value={regularVacation}
                onChange={(e) => setregularVacation(e.target.value)}
                focused
                type="number"
                variant="outlined"
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    اجازة عارضة (بالايام)
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                value={casualVacation}
                onChange={(e) => setcasualVacation(e.target.value)}
                focused
                variant="outlined"
                type="number"
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                label={
                  <Typography sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                    اجازة مرضي (بالايام)
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                value={sickVacation}
                onChange={(e) => setsickVacation(e.target.value)}
                focused
                type="number"
                //   className="ww"
              />
            </div>
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
          {Eye ? (
            <button className="buttonadd" onClick={handlePrint}>
              تصدير
            </button>
          ) : (
            <>
              {isEdit ? (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handleUpdate}>
                      تعديل
                    </button>
                  )}
                </>
              ) : (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handlesubmit}>
                      إضافة
                    </button>
                  )}
                </>
              )}
            </>
          )}{" "}
          <div className="inputs-container ddl">
            <div className="inp-container ">
              <TextField
                label="ابحث"
                inputProps={{ maxLength: 120 }}
                type="text"
                variant="outlined"
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSearch();
                }}
                value={Search}
              />
              <i
                className="ty fa-solid fa-magnifying-glass"
                onClick={handleSearch}></i>
            </div>
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
          <button className="buttonadd" type="button" onClick={handleSearch}>
            بحث
          </button>
        </Container>{" "}
        <Table
          ref={tableRef}
          id="my-table"
          className="maint"
          responsive
          striped
          bordered
          hover>
          <thead>
            <tr>
              <th>
                اسم الموظف <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                اجازة سنوية <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                اجازة اعتيادية<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                اجازة عارضة <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                اجازة مرضي <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {filteredHolidays.length > 0
              ? filteredHolidays.map((item, idx) => {
                  // ForceCount = ALL.TotalPages - 1;
                  return (
                    <tr key={idx} onDoubleClick={() => Update(item)}>
                      <td>{item.employeeName}</td>
                      <td>{item.annualVacation}</td>
                      <td>{item.regularVacation}</td>
                      <td>{item.casualVacation}</td>
                      <td>{item.sickVacation}</td>
                      <td className="icon-w" onClick={() => Update(item)}>
                        <i
                          className="fa fa-solid fa-pen-to-square icon-blue"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        {" "}
                        <i
                          onClick={() => handleShoweDelete(item.id)}
                          className="fs fa-solid fa-trash-can icon-red"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        <i
                          onClick={() => Showw(item)}
                          className="fa-solid fa-eye"
                          style={{ color: "#333" }}></i>
                      </td>
                    </tr>
                  );
                })
              : null}
          </tbody>
        </Table>
        <ToastContainer autoClose={1200} />
        <Pagination
          onPress={onPress}
          PageSize={PageSize}
          PageCount={All ? All.totalPages : null}
          // ForceCount={ForceCount}
          // itemsPerPage={2}
          // items={FilesDetails.data}
        />
        <button className="buttonadd" onClick={onDownload}>
          تصدير
        </button>
      </div>
      <Modal
        show={showManage}
        onHide={handleCloseManage}
        backdrop="static"
        keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>الإدارة</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <NEMPsearch />
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleCloseManage}>
            إغلاق
          </Button>
          {/* <Button variant="primary" className="edit">
            إختيار
          </Button> */}
        </Modal.Footer>
      </Modal>
      <div className="mod">
        <Modal
          show={showDelete}
          onHide={handleCloseDelete}
          backdrop="static"
          centered
          contentClassName="cont"
          keyboard={false}
          style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
          {/* <Modal.Header closeButton>
                <Modal.Title> </Modal.Title>
              </Modal.Header> */}
          <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleCloseDelete}>
              إغلاق
            </Button>
            <Button
              variant="primary"
              className="edit"
              onClick={handelDeleteItem}>
              موافق
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <FormPrintView
        ref={myDivRefWorkcom}
        title="بيانات الإجازات"
        fields={[
          { label: "اسم الموظف", value: formatPrintValue(EmployeesId) },
          { label: "اجازة سنوية", value: formatPrintValue(annualVacation) },
          { label: "اجازة اعتيادية", value: formatPrintValue(regularVacation) },
          { label: "اجازة عارضة", value: formatPrintValue(casualVacation) },
          { label: "اجازة مرضي", value: formatPrintValue(sickVacation) },
        ]}
      />
    </>
  );
};
export default Enter;
